import script from "./policy-delete-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./policy-delete-modal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__